// ImageEnum.js
export const ImageEnum = Object.freeze({
    MOD_IOT_GATEWAY: "MOD-IOT-Gateway.jpg",
    IO_CONTROLLER: "iocontroller.jpg",
    HMI_TOUCH_PANEL: "hmi.jpg",
    IOT_4G_GATEWAY: "iotgateway4g.png",
    IOT_DASHBOARD: "dashboard.png"
  });


export const ServicesEnum = Object.freeze({
INDUSTRIAL_4:"iot.png",
IOT:"iot.png",
AUTOMATIVE:"automation.png",
AI:"ai1.png",
EMBEDDED:"embedded1.png",
FIRMWARE:"firmware.png",
MANUFACTURING:"manufacturing.png",
CONSULTING:"consulting1.png",
MAINTENANCE:"maintenance.png",
COMPLIANCE:"compliance.png"
});
  

